module.exports = __webpack_public_path__ + "media/mek3.6e768dd6.webm";